import { render, staticRenderFns } from "./downloads.vue?vue&type=template&id=1b48f978"
import script from "./downloads?vue&type=script&lang=js&external"
export * from "./downloads?vue&type=script&lang=js&external"
import style0 from "./downloads.vue?vue&type=style&index=0&id=1b48f978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports